
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/aktuelle-jobs/[slug]",
      function () {
        return require("private-next-pages/[lang]/aktuelle-jobs/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lang]/aktuelle-jobs/[slug]"])
      });
    }
  